import { ConnectorServiceEnum } from '@enum/connector-service.enum';
import { UnifiedApiEnum } from '@enum/unified-api.enum';

export enum ConnectionStateEnum {
  Added = 'added',
  Available = 'available',
  Callable = 'callable',
  Authorized = 'authorized',
  INVALID = 'invalid',
}

interface ConnectionSettingsInterface {
  domain: string | null;
  apiKey: string | null;
}

export interface ConnectionFTPInterface {
  endpoint: string;
  password: string;
  username: string;
}

export interface ConnectionInterface {
  id: string;
  serviceId: ConnectorServiceEnum;
  name: string;
  unifiedApi: string;
  enabled: boolean;
  consumer: string;
  state: ConnectionStateEnum;
  authorizeUrl?: string | null;
  settings: ConnectionSettingsInterface;
  ftp?: ConnectionFTPInterface;
}

export interface ConnectionInputInterface {
  unifiedApi: UnifiedApiEnum;
  serviceId: ConnectorServiceEnum;
  name: string;
  enabled: boolean;
  settings: ConnectionSettingsInterface;
}

export interface ConnectionMetaInputInterface {
  unifiedApi: UnifiedApiEnum;
  serviceId: ConnectorServiceEnum;
  file: any;
}
